import { GetterTree, MutationTree, ActionTree, Module } from "vuex";
import { RootState } from "..";
import { ClientModel, ClientClient } from "@/core/api/apiClient";
import Vue from "vue";

class ClientsState {
  items: ClientModel[] | undefined = undefined;
}

export const state: ClientsState = {
  items: undefined
};

const namespaced: boolean | undefined = true;

const getters = {
  items(state) {
    if (!state.items) return [];

    return state.items.slice().sort((a, b) => {
      const nameA = a.name ?? ""; // treat null/undefined as empty string
      const nameB = b.name ?? "";
      return nameA.localeCompare(nameB);
    });
  },
  item:
    (state) =>
    (ClientId: string): ClientModel | undefined => {
      if (!state.items) {
        return undefined;
      }

      const client = state.items.find((x) => x.clientId == ClientId);

      return client;
    }
} as GetterTree<ClientsState, any>;

const mutations = {
  SET_CLIENTS(state, clients: ClientModel[]) {
    state.items = clients;
  },
  UPDATE_CLIENT(state, client: ClientModel) {
    if (!state.items) return;

    const existingItem = state.items.findIndex((x) => x.clientId === client.clientId);

    if (existingItem !== -1) {
      Vue.set(state.items, existingItem, client);
    } else {
      state.items.push(client);
    }
  },
  REMOVE_CLIENT(state, ClientId: string) {
    if (state.items != undefined) {
      state.items = state.items?.filter((x) => x.clientId != ClientId);
    }
  }
} as MutationTree<ClientsState>;

const actions = {
  async fetchClients({ commit }) {
    const clientClient = new ClientClient();

    await clientClient.listClients().then((data) => {
      if (!data.hasError && data.model) {
        commit("SET_CLIENTS", data.model);
      }
    });
  },

  async setClient(
    { commit },
    payload: {
      newClient: ClientModel;
      logo: File | undefined;
    }
  ): Promise<any | ClientModel> {
    const { newClient, logo } = payload;

    const clientClient = new ClientClient();
    await clientClient
      .createClient(
        newClient.name,
        newClient.mainThemeColor,
        newClient.mainThemeTextColor,
        newClient.workingDays,
        newClient.jobSchedulerTimeIntervals,
        logo == undefined ? undefined : { fileName: logo.name, data: logo }
      )
      .then((data) => {
        if (!data.hasError && data.model) {
          commit("UPDATE_CLIENT", data.model);
        }
      });
  },
  async removeClient({ commit }, client: ClientModel): Promise<any> {
    const clientClient = new ClientClient();

    await clientClient.deleteClient(client.clientId).then(async () => {
      commit("REMOVE_CLIENT", client.clientId);
    });
  }
} as ActionTree<ClientsState, any>;

export const clients: Module<ClientsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
